import { useCallback } from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { THEME_COLORS, type ThemeName } from '../utils/themeColors';
import type { Folder } from '../types';

export function useFolderColor() {
  const { currentTheme } = useSettings();

  return useCallback(
    (folder: Folder) => {
      // Special folders always use their defined color
      if (folder.isSpecial) {
        return folder.color;
      }

      // Check if folder uses any theme's default color
      const isDefaultLight = folder.color === THEME_COLORS.light;
      const isDefaultDark = folder.color === THEME_COLORS.dark;
      const isDefaultSpotify = folder.color === THEME_COLORS.spotify;
      const usesDefaultColor = isDefaultLight || isDefaultDark || isDefaultSpotify;

      // If using a default color, return current theme's default
      if (usesDefaultColor) {
        return THEME_COLORS[currentTheme as ThemeName] || THEME_COLORS.light;
      }

      // Otherwise it's a custom color, use it as-is
      return folder.color;
    },
    [currentTheme]
  );
}
